import * as Yup from "yup";
import { TextField } from "src/components/FormField/TextField";
import { EMAIL_VALIDATION_SCHEMA } from "src/constants/formValidation";
import { formFieldTrns } from "src/components/FormField/trns";
import { IRenderFormField } from "src/@types/form";

const DEFAULT_ERROR_CLASSNAME =
  "absolute -bottom-6 w-full !font-medium text-sm text-center leading-none";

export const LOGIN_FORM_FIELDS: IRenderFormField[] = [
  {
    name: "email",
    type: "email",
    label: { i18nKey: formFieldTrns.email },
    className: "h-11",
    labelClassName: "lowercase",
    fieldClassName: "text-sm",
    errorClassName: DEFAULT_ERROR_CLASSNAME,
    component: TextField,
  },
  {
    name: "password",
    type: "password",
    label: { i18nKey: formFieldTrns.password },
    className: "h-11",
    labelClassName: "lowercase",
    fieldClassName: "text-sm",
    errorClassName: DEFAULT_ERROR_CLASSNAME,
    component: TextField,
  },
];

export const LOGIN_VALIDATION_SCHEMA = Yup.object().shape({
  email: EMAIL_VALIDATION_SCHEMA,
  password: Yup.string().required("required"),
});
